import { Component } from '@angular/core';
import { OpenOrderRowsConfigService } from '../../services/open-order-rows-config/open-order-rows-config.service';

@Component({
    selector: 'lib-open-order-rows',
    templateUrl: './open-order-rows.component.html',
    styleUrl: './open-order-rows.component.scss',
    standalone: false
})
export class OpenOrderRowsComponent {
  constructor(public config: OpenOrderRowsConfigService) {}
}
